import React, { ReactElement } from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { createOptionsList } from '../../../services/common/miscUtils';
import { CorrespondenceMethodEnum, NoYesEnum } from '../../../types/forms';
import { PhoneNumberFormField } from '../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { TradingDetailsServicePlanFormModelFieldsNew } from './formModel';

export const createFormInputs = ((disableAllFormControls: boolean) => {
  return {
    legalName: () => (
      <TextInputFormField
        fieldName="legalName"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanForm:fields:legalName:label"
        placeholderTranslationKey="tradingDetailsServicePlanForm:fields:legalName:placeholder"
      />
    ),
    vatLiable: () => (
      <SelectFormField
        fieldName="vatLiable"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanForm:fields:vatLiable:label"
        optionList={createOptionsList(NoYesEnum, 'tradingDetailsServicePlanForm', 'noYes', null)}
      />
    ),
    tradingAs: () => (
      <TextInputFormField
        fieldName="tradingAs"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanForm:fields:tradingAs:label"
        placeholderTranslationKey="tradingDetailsServicePlanForm:fields:tradingAs:placeholder"
      />
    ),
    vatNumber: () => (
      <TextInputFormField
        fieldName="vatNumber"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanForm:fields:vatNumber:label"
        placeholderTranslationKey="tradingDetailsServicePlanForm:fields:vatNumber:placeholder"
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName="email"
        isDisabled={disableAllFormControls}
        labelTranslationKey="customerDetailsForm:fields:email:label"
        placeholderTranslationKey="customerDetailsForm:fields:email:placeholder"
        validateOnChange
      />
    ),
    mobileNumber: () => {
      return (
        <PhoneNumberFormField
          fieldName="mobileNumber"
          isDisabled={disableAllFormControls}
          labelTranslationKey="customerDetailsForm:fields:mobileNumber:label"
          placeholderTranslationKey="customerDetailsForm:fields:mobileNumber:placeholder"
          type="mobile"
        />
      );
    },
    countryCode: () => (
      <SelectFormField
        fieldName="countryCode"
        isDisabled={disableAllFormControls}
        labelTranslationKey="customerDetailsForm:fields:countryCode:label"
        optionList={createOptionsList(PhoneCountryCodeType, 'customerDetailsForm', 'countryCode')}
      />
    ),
    correspondenceMethod: () => (
      <SelectFormField
        fieldName="correspondenceMethod"
        isDisabled={disableAllFormControls}
        labelTranslationKey="customerDetailsForm:fields:correspondenceMethod:label"
        optionList={createOptionsList(CorrespondenceMethodEnum, 'customerDetailsForm', 'correspondenceMethod')}
      />
    ),
  };
}) satisfies (
  disableAllFormControls: boolean
) => Record<TradingDetailsServicePlanFormModelFieldsNew, (...args: any[]) => ReactElement>;
